import { cn } from "@-/com.npmjs.cn";
import { cva, type VariantProps } from "@-/com.npmjs.cva";
import type { ComponentProps } from "react";

const websiteCardVariants = cva({
  base: "rounded-xs border border-black/10 bg-white text-black shadow-lg shadow-black/5",
  defaultVariants: {
    padding: "default",
  },
  variants: {
    padding: {
      default: "p-6 sm:p-8",
      /** For cards that lay out their own insets (e.g. a QR code flush with the edge). */
      none: "",
    },
  },
});

/** A raised white panel: support options, forms, the landing's QR code. */
export function WebsiteCard({
  className,
  padding,
  ...props
}: ComponentProps<"div"> & VariantProps<typeof websiteCardVariants>) {
  return <div className={cn(websiteCardVariants({ padding }), className)} {...props} />;
}
